import { sliderMediaBreakPoints } from '@helpers/utils.js';
import TabContentFields from '../fields/tabContentFields';

const {
  i18n: { __ },
  components: { PanelBody },
} = wp;

const TabNavSettings = ({
  tabContentSliderSettings,
  setSliderSettingAttribute,
  tabContents,
  removeSliderSettingAttribute,
}) => {
  return (
    <>
      <PanelBody title={__('Content Settings', 'b3rg')} initialOpen={false}>
        {sliderMediaBreakPoints
          .map((sliderMediaBreakPoint) => {
            const breakPoint = sliderMediaBreakPoint.breakPoint;
            const deviceSlug = sliderMediaBreakPoint.slug;
            return (
              <TabContentFields
                key={breakPoint}
                {...{
                  sliderMediaBreakPoint,
                  sliderSettings: tabContentSliderSettings[deviceSlug],
                  slides: tabContents,
                  setSliderSettingAttribute,
                  removeSliderSettingAttribute,
                }}
              />
            );
          })
          .reverse()}
      </PanelBody>
    </>
  );
};

export default TabNavSettings;
